import axios from 'axios';
import { API_BASE } from '../../../scripts/utils/api';

// Compared lowercase: the register form writes Club_Intersport.
const CLUB_TAG = 'club_intersport';

async function checkMember() {
  const body = document.querySelector('body');
  const isLoggedIn = body.dataset.loggedIn === 'true';

  if (!isLoggedIn) {
    return;
  }

  const isMember = await hasClubTag();

  if (isMember === false) {
    await enrolAsMember();
  }

  await Shopify.functions.getMember();

  Shopify.functions.showMemberSections(true);
}

async function hasClubTag() {
  const customer = window.customer;
  if (!customer?.id) return null;

  try {
    const shopifyCustomer = await axios.get(`${API_BASE}/getCustomer?id=${customer.id}`);
    const tags = (shopifyCustomer?.data?.tags || '')
      .toLowerCase()
      .split(',')
      .map((tag) => tag.trim());

    return tags.includes(CLUB_TAG);
  } catch (error) {
    console.log('🚀 ~ could not read customer tags:', error);
    return null;
  }
}

async function enrolAsMember() {
  const customer = window.customer;

  try {
    await axios.post(`${API_BASE}/updateCustomerTags`, { email: customer?.email });
  } catch (error) {
    console.log('🚀 ~ error:', error);
  }
}

checkMember();
